<template>
  <div>
    <img
      ref="img"
      crossorigin
      :src="imageUrl"
      :style="maxHeight ? 'max-height:' + maxHeight : ''"
    />
    <canvas
      ref="canvas"
      crossorigin
      tabindex="0"
      @click="onClick"
      @keydown="onKeyDown"
      @blur="
        track = false;
        initKeyboardDrawing = true;
      "
      @focus="setInitialCoordinates"
    ></canvas>
  </div>
</template>

<script>
export default {
  name: 'Draw',
  props: {
    imageUrl: {
      required: true,
      type: String,
    },
    maxHeight: {
      type: String,
    },
  },

  data() {
    return {
      markerX: null,
      markerY: null,
      track: false,
      ctx: null,
      initKeyboardDrawing: true,
    };
  },

  methods: {
    onClick(e) {
      this.track = true;
      this.draw(e);

      this.$emit('change', {
        base64: this.$refs.canvas.toDataURL('image/jpeg'),
      });
      this.track = false;
    },

    onMouseDown(e) {
      e.preventDefault();
      this.track = true;
    },

    onMouseUp(e) {
      e.preventDefault();
      this.track = false;

      this.drawMarker(false);

      this.$emit('change', {
        base64: this.$refs.canvas.toDataURL('image/jpeg'),
      });
    },

    onMouseMove(e) {
      e.preventDefault();
      this.draw(e);
    },

    onKeyDown(e) {
      switch (e.keyCode || (e.which && (e.keyCode || e.which))) {
        case 17 && 37:
          this.track = true;
          this.keyboardDraw(e);
          break;
        case 17 && 38:
          this.track = true;
          this.keyboardDraw(e);
          break;
        case 17 && 39:
          this.track = true;
          this.keyboardDraw(e);
          break;
        case 17 && 40:
          this.track = true;
          this.keyboardDraw(e);
          break;
        default:
          break;
      }

      if (this.track && (e.keyCode == 13 || e.keyCode == 13)) {
        this.$emit('change', {
          base64: this.$refs.canvas.toDataURL('image/jpeg'),
        });
        this.track = false;
      }
    },

    keyboardDraw(e) {
      if (!this.track) return;

      //Left arrow
      if (e.ctrlKey && (e.keyCode == 37 || e.which == 37)) {
        this.markerX = this.markerX - 5;
      }
      //Up arrow
      if (e.ctrlKey && (e.keyCode == 38 || e.which == 38)) {
        this.markerY = this.markerY - 5;
      }
      //Right arrow
      if (e.ctrlKey && (e.keyCode == 39 || e.which == 39)) {
        this.markerX = this.markerX + 5;
      }
      //Down arrow
      if (e.ctrlKey && (e.keyCode == 40 || e.which == 40)) {
        this.markerY = this.markerY + 5;
      }
      this.clearCanvas();
      this.drawMarker(e.type !== 'click');
    },

    setInitialCoordinates() {
      this.clearCanvas();

      // http://ictknowledge.net/html-canvas-resize-and-mouse-coordinates/
      var rect = this.$refs.canvas.getBoundingClientRect();
      var X = rect.left / (this.$refs.canvas.clientWidth / this.$refs.canvas.width);
      var Y = rect.top / (this.$refs.canvas.clientHeight / this.$refs.canvas.height);
      this.markerX = Math.ceil(X - rect.x * 0.9);
      this.markerY = Math.ceil(Y - rect.y * 0.8);
    },

    draw(e) {
      if (!this.track) return;

      this.clearCanvas();

      // Antingen ett MouseEvent eller TouchEvent
      let { clientX, clientY } = e.touches ? e.touches[0] : e;

      // http://ictknowledge.net/html-canvas-resize-and-mouse-coordinates/
      var rect = this.$refs.canvas.getBoundingClientRect();
      var X = (clientX - rect.left) / (this.$refs.canvas.clientWidth / this.$refs.canvas.width);
      var Y = (clientY - rect.top) / (this.$refs.canvas.clientHeight / this.$refs.canvas.height);
      this.markerX = Math.ceil(X);
      this.markerY = Math.ceil(Y);

      this.drawMarker(e.type !== 'click');
    },

    /**
     * Ritar ut markering på x och y
     */
    drawMarker(moving) {
      // ritar ut bilden
      this.ctx.beginPath();

      //Set line to 5px
      this.ctx.lineWidth = 5;

      // Kryss
      this.ctx.moveTo(this.markerX - 20, this.markerY - 20);
      this.ctx.lineTo(this.markerX + 20, this.markerY + 20);
      this.ctx.stroke();

      this.ctx.moveTo(this.markerX + 20, this.markerY - 20);
      this.ctx.lineTo(this.markerX - 20, this.markerY + 20);
      this.ctx.stroke();

      // Boll
      // this.ctx.arc(this.markerX, this.markerY, 18, 0, 2*Math.PI);

      // this.ctx.fillStyle = (moving) ? 'rgba(0, 0, 0, 0.5' : 'rgba(0, 0, 0, 0.7)';
      // this.ctx.fill();
    },

    clearCanvas() {
      this.ctx.drawImage(this.$refs.img, 0, 0, this.$refs.canvas.width, this.$refs.canvas.height);
    },
  },

  mounted() {
    this.ctx = this.$refs.canvas.getContext('2d');

    this.$refs.img.onload = (e) => {
      // canvas ska ha samma proportioner som bilden
      this.$refs.canvas.height = e.target.height;
      this.$refs.canvas.width = e.target.width;

      // Rita ut bilden
      this.clearCanvas();
      $('canvas').focus();
    };
  },
};
</script>
